import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { View, TextInput, Text, Icon } from './components/primitives'
import Select from './components/Select'
import TreeSelect from './components/TreeSelect'
import Option from './components/Option'
import TreeOptionList from './components/TreeOptionList'
import ResultingVacancies from './components/ResultingVacancies'
import Dropdown from './components/Dropdown'
import SelectedItem from './components/SelectedItem'
import history from './history'
import provideUrlProps from './provideUrlProps'

import { initialQueryLength } from './config'

const Container = View.extend.attrs({
    className:
        process.env.REACT_APP_ISOLATED === 'true' &&
            process.env.NODE_ENV === 'development'
            ? 'o-container--m'
            : null,
})`
  ${`margin-top: 5px`};
`

const Filter = styled(({ home, ...rest }) => <View {...rest} />).attrs({
    className: 'c-home-blocks'
})`
  ${props =>
        !props.home &&
        `
    border: 1px solid ${props.theme.colors.borderColor};
    background-color: ${props.theme.colors.accent3Color};
    box-shadow: none;`};
`

const Block = styled(({ first, bg, ...rest }) => <View {...rest} />)`
  position: relative;
  flex: 1;
  height: 60px;
  ${props => props.bg && 'background-color: white;'} border: 1px solid ${({
    theme: { colors }
}) => colors.borderColor};
  ${props =>
        !props.first &&
        `
    @media(min-width: 720px) {
      border-left-width: 0;
    }
    @media(max-width: 719px) {
      border-top-width: 0;
      height: 54px;
    }
  `};
`

const DropdownButton = View.extend`
  display: flex;
  width: 100%;
  height: 100%;
  padding-left: 12px;
  padding-right: 24px;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background-color: ${({ theme: { colors } }) => colors.accent3Color};
  }
`

const ButtonText = Text.extend`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const DropdownContent = View.extend.attrs({
    py: 2,
    pl: 2,
    pr: 2
})`
  width: calc(100% + 2px);
  margin-left: -1px;
  background-color: white;
  border: 1px solid ${({ theme: { colors } }) => colors.borderColor};
`

const QueryInput = TextInput.extend.attrs({
    className: ''
})`
  border: none;
  height: 100%;
`

const SearchIcon = Icon.extend.attrs({ icon: 'search', m: 2 })`
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -12px;
  color: ${({ theme: { colors } }) => colors.accent2Color};
  pointer-events: none;
  @media(min-width: 720px) {
    display: none;
  }
`

const SearchButton = Block.extend.attrs({
    className: 'c-btn'
})`
  display: flex;
  flex: 0.5;
  justify-content: center;
  cursor: pointer;
  border-radius: 0;
  line-height: 2.5;
  &:hover {
    background-color: ${({ theme: { colors } }) => colors.primary1HoverColor};
  }
  &:after {
    content: '';
  }
  ${({ disabled, theme: { colors } }) =>
        disabled === true &&
        `background-color: ${colors.disabledColor}; pointer-events: none;
    &:hover {
      background-color: ${colors.disabledColor};
    }
  `}
`

const FilterStatusBar = View.extend`
  font-size: ${({ theme: { fontSizes } }) => fontSizes[1]}px;
  @media (max-width: 719px) {
    margin-left: -8px;
  }
`

const YourSelection = Text.extend`
  display: inline-block;
  margin-right: 0.25em;
  @media (max-width: 719px) {
    display: block;
    margin: 12px 8px;
  }
  font-weight: ${({ theme: { fontWeights } }) => fontWeights.bold};
`

const ClearFilters = YourSelection.extend.attrs({ mx: 1, px: 1 })`
  color: ${({ theme: { colors } }) => colors.accent1Color};
  cursor: pointer;
  &:hover {
    color: ${({ theme: { colors } }) => colors.primary2HoverColor};
  }
`

const ChevronDown = Icon.extend.attrs({
    icon: 'keyboard-arrow-down',
    size: 20,
    color: 'alternateTextColor'
})`
position: absolute;
right: 4px;
top: 20px;
`

const NotOnMobile = View.extend`
  @media (max-width: 640px) {
    display: none;
  }
`

const Title = Text.extend`
    position: relative;
    display: block;
    flex: 1 0 100%;
    color: ${({ theme: { colors } }) => colors.accent1Color};
    z-index: 7;
    bottom: 12px;
`

// When hitting 'Search', freeze the current state and use that for the api request
// The 'provideUrlProps' HOC has made all location attributes available through props
const freezeFilters = (props, filters) => {

    // Get query data
    const queryDataReduced = filters.reduce(
        (collect, filter) =>
            props[filter] ? { ...collect, [filter]: props[filter] } : collect,
        {}
    )

    // Get values by key from props.model
    const queryData = Object.assign({}, ...Object.entries(queryDataReduced).map(([key, filter]) => {
        return {
            [key]: filter.map(item => {
                return props.model.vacancyFilter[key].find((x) => x.value === item).value
            })
        }
    }))

    // Set other query params
    queryData.searchQuery = props.searchQuery
    queryData.orderByCreatedDate = props.model.orderByCreatedDate
    queryData.OrderByHighlighted = props.model.orderByHighlighted

    return queryData
}

const detectIE = () => {
    const ua = window.navigator.userAgent
    return ua.indexOf('MSIE ') > -1
}

const capitalize = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

class Main extends Component {
    constructor(props) {
        super(props)

        const filters = Object.keys(props.model.vacancyFilter).reduce(
            (collect, key) => [...collect, key],
            []
        )

        const queryData = freezeFilters(props, filters)

        this.state = {
            filters,
            queryData,
            forceRefreshKey: 0,
            show: props.show || initialQueryLength,
            queryMutated: false,
            searchQueryInState: null,
        }
        this.timeout = 0
    }
    clearFilters = () => {
        this.state.filters.concat(['areas']).forEach(filter => {
            if (this.props['onChange' + capitalize(filter)]) {
                this.props['onChange' + capitalize(filter)]([])
            }
        })
        this.setState({
            queryMutated: true,
            searchQueryInState: null
        })
        this.props.onChangeSearchQuery("")
        this.queryInputField.value = ""
    }
    select = (filter, values) => {
        this.props['onChange' + capitalize(filter)](values)
        this.setState({
            queryMutated: true
        })
    }
    selectMultiple = (filters) => {
        filters.forEach(item => {
            this.props['onChange' + capitalize(item.filter)](item.values)
        })
        this.setState({
            queryMutated: true
        })
    }
    deselect = (filter, value) => {
        const values = this.props[filter].filter(_value => _value !== value)
        this.props['onChange' + capitalize(filter)](values)
        this.setState({
            queryMutated: true
        })
    }
    handleSearch = () => {
        if (!this.props.model.showResults) {
            window.location.href =
                ('results' in this.props.model.urls
                    ? this.props.model.urls.results
                    : 'vacancies') + history.location.search
        } else {
            const queryData = freezeFilters(this.props, this.state.filters)
            this.setState(state => ({
                queryData,
                forceRefreshKey: state.forceRefreshKey + 1,
                show: initialQueryLength,
                queryMutated: false
            }))
            this.props.onChangeShow(null)
        }
    }
    ForceHttps = (url) => {
        if (url.match('^http://')) {
            return url.replace("http://", "https://");
        }
        return url;
    }
    searchQueryUpdate = value => {
        // throttle, for IE
        clearTimeout(this.timeout)
        const ms = detectIE() ? 400 : 100
        this.timeout = setTimeout(() => this.delayedSearchQueryUpdate(value), ms)
    }
    delayedSearchQueryUpdate = value => {
        this.props.onChangeSearchQuery(value)
        this.setState({ queryMutated: true, searchQueryInState: value })
    }
    isChecked = (filter, value) => {
        return this.props[filter] && this.props[filter].includes(value)
    }
    handleKeyPress = (event) => {
        if(!!this.queryInputField.value && event.key === 'Enter') {
          this.handleSearch()
        }
    }
    render() {

        const {
            searchQuery,
            translations,
            // urls = null,
            model: { urls },
            model,
            onChangeShow
        } = this.props
        const {
            filters,
            forceRefreshKey,
            show,
            queryMutated,
            searchQueryInState
        } = this.state
        // Check if any filters are selected
        const selectionActive = filters.map(filter => {
            return (this.props.model.vacancyFilter[filter]
                .reduce((acc,item) => {
                    if (item.children) {
                        acc = acc.concat(item.children.map(child => {
                            child.filter = 'areas'
                            return child
                        }))
                    }
                    acc.push(item)
                    return acc
                },[])
                .filter(item => {
                return (
                    typeof this.props[item.filter || filter] === 'object' &&
                    this.props[item.filter || filter].includes(item.value)
                )
            })).length > 0
        }).includes(true)

        return (
            <Container>

                {/* FILTER BAR */}
                <Filter home={!model.showResults}>
                    <Title style={{ textAlign: this.props.model.alignTitleCenter? "center": "left"}}>{this.props.model.title}</Title>
                    <Block first>
                        <QueryInput
                            _ref={ref => this.queryInputField = ref}
                            onChangeText={value => this.searchQueryUpdate(value)}
                            placeholder={translations['searchPlaceholder']}
                            defaultValue={searchQueryInState || searchQuery || ''}
                            onKeyPress={this.handleKeyPress}
                        />
                        <SearchIcon />
                    </Block>
                    {filters.filter(filterValue => filterValue !== 'areas').map(filter => (
                        <Block key={filter} bg>
                            <Dropdown>
                                <DropdownButton>
                                    <ButtonText>{translations[filter]}</ButtonText>
                                    <ChevronDown />
                                </DropdownButton>
                                <DropdownContent>
                                    {(model.vacancyFilter[filter][0] && model.vacancyFilter[filter][0].children && model.vacancyFilter[filter][0].children.length > 0)
                                        ?
                                        <TreeSelect
                                            onChange={(filters) => this.selectMultiple(filters)}
                                            selectedParent={this.props[filter]}
                                            selectedChildren={this.props['areas']}>
                                            {model.vacancyFilter[filter].map(({ label, value, children }) => (
                                                <TreeOptionList
                                                    key={value}
                                                    value={value}
                                                    label={label}
                                                    subOptions={children}
                                                    selectedParent={this.props[filter]}
                                                    selectedChildren={this.props['areas']}
                                                    parentFilter={filter}
                                                    childFilter='areas'
                                                >
                                                    {label}
                                                </TreeOptionList>
                                            ))}
                                        </TreeSelect>
                                        :
                                        <Select onChange={values => this.select(filter, values)}>
                                            {model.vacancyFilter[filter].map(({ label, value }) => (
                                                <Option
                                                    key={value}
                                                    value={value}
                                                    checked={
                                                        this.props[filter] &&
                                                        this.props[filter].includes(value)
                                                    }
                                                >
                                                    {label}
                                                </Option>
                                            ))}
                                        </Select>
                                    }
                                </DropdownContent>
                            </Dropdown>
                        </Block>
                    ))}
                    <SearchButton
                        onClick={this.handleSearch}
                        disabled={
                            (!queryMutated && model.showResults) ||
                            (Object.keys(this.state.queryData).length === 0 &&
                                !model.showResults &&
                                !queryMutated)
                        }
                    >
                        {translations['search']}
                    </SearchButton>
                </Filter>

                {/* FILTER STATUS */}
                {selectionActive && (
                    !(Object.keys(this.state.queryData).length === 0) ||
                    queryMutated
                ) && (
                        <FilterStatusBar>
                            <YourSelection>{translations['yourSelection']}</YourSelection>
                            {filters.filter(filterValue => filterValue !== 'areas').map(filter => (
                                <Fragment key={filter}>
                                    {model.vacancyFilter[filter].map(({ label, value }) => {
                                        return (
                                            typeof this.props[filter] === 'object' &&
                                            this.props[filter].includes(value) && (
                                                <SelectedItem
                                                    key={value}
                                                    onClick={() => this.deselect(filter, value)}
                                                >
                                                    {label}
                                                </SelectedItem>
                                            )
                                        )
                                    })}
                                </Fragment>
                            ))}
                            <Fragment key='areas'>
                                {model.vacancyFilter['locationCountries'].reduce((acc,country) => {
                                    acc.push(...country.children)
                                    return acc
                                },[])
                                .map(({ label, value }) => {
                                    return (
                                        typeof this.props['areas'] === 'object' &&
                                        this.props['areas'].includes(value) && (
                                            <SelectedItem
                                                key={value}
                                                onClick={() => this.deselect('areas', value)}
                                            >
                                                {label}
                                            </SelectedItem>
                                        )
                                    )
                                })}
                            </Fragment>
                            <ClearFilters onClick={this.clearFilters}>
                                {translations['clearAll']}
                            </ClearFilters>
                        </FilterStatusBar>
                    )}

                {/* VACANCIES RETRIEVED THROUGH SEARCH QUERY */}
                {model.showResults && (
                    <ResultingVacancies
                        queryData={this.state.queryData}
                        key={forceRefreshKey}
                        favourites={this.props.favourites}
                        toggleFavourite={this.props.toggleFavourite}
                        API={urls ? this.ForceHttps(urls['api']) : 'https://rnw.herokuapp.com/'}
                        index={0}
                        show={show}
                        onChangeShow={onChangeShow}
                        disciplines={model['disciplines']}
                        experiences={model['experiences']}
                        areas={model['areas']}
                        locationCountries={model['LocationCountries']}
                    />
                )}

            </Container>
        )
    }
}

class App extends Component {
    componentDidMount() {
        // force an update if the URL changes
        history.listen(() => this.forceUpdate())
    }
    render() {
        return <AppWithUrlProps {...this.props} />
    }
}

const AppWithUrlProps = provideUrlProps(Main)

export default App
